// Copyright ID Business Solutions Ltd. 2023

import styled from 'styled-components';

export const UnselectButtonWrapper = styled.div`
  /*margin-left: 10px;*/
`;
